import { useMatchMedia } from './useMatchMedia.ts';

type ColorScheme = 'light' | 'dark';

/**
 * {@link usePrefersColorScheme} is a react hook that checks and watches for changes to
 * the user's OS-level theme preferences, and returns either 'light' or 'dark'
 * based on that preference, falling back to a default if no preference is set.
 */
export function usePrefersColorScheme(defaultScheme: ColorScheme) {
  let scheme: ColorScheme;

  const isLight = useMatchMedia('(prefers-color-scheme: light)');
  const isDark = useMatchMedia('(prefers-color-scheme: dark)');

  if (isDark) {
    scheme = 'dark';
  } else if (isLight) {
    scheme = 'light';
  } else {
    scheme = defaultScheme;
  }

  return scheme;
}
